export let DEFAULT_COUNTRY_PHONE_CODE = "+39";
export let DEFAULT_CURRENCY = "EUR";



